import { useTranslation } from 'react-i18next';

export const ns = 'user-details-page';
export const useUserDetailsPageTranslation = () => useTranslation(ns);

export const ruRu = (__LOCALE_RU__ ? ({
  [ns]: {
    breadcrumb: 'Пользователи',
    active: 'Активный',
    pending: 'Ожидает установки пароля',
    blocked: 'Заблокирован',
    info: {
      title: 'Полезно знать',
      content: `
        <span>
          Перечень тегов доступа и списков пользователя определяется его подразделениями.
        </span>
        <span>
          Перечень доступов пользователя к страницам и объектам системы определяется его ролью.
        </span>
      `,
    },
  },
}) : {}) as Record<string, unknown>;

export const en = (__LOCALE_EN__ ? ({
  [ns]: {
    breadcrumb: 'Users',
    active: 'Active',
    pending: 'Pending password setup',
    blocked: 'Blocked',
    info: {
      title: 'Good to know',
      content: `
        <span>
          The list of user access tags and lists is determined by their departments.
        </span>
        <span>
          The list of user access rights to system pages and objects is determined by their role.
        </span>
      `,
    },
  },
}) : {}) as Record<string, unknown>;

export const esEs = (__LOCALE_ESES__ ? ({
  [ns]: {
    breadcrumb: 'Usuarios',
    active: 'Activo',
    pending: 'Pendiente de configurar contraseña',
    blocked: 'Bloqueado',
    info: {
      title: 'Útil saber',
      content: `
        <span>
          La lista de etiquetas de acceso y listas del usuario está determinada por sus departamentos.
        </span>
        <span>
          La lista de accesos del usuario a las páginas y objetos del sistema está determinada por su rol.
        </span>
      `,
    },
  },
}) : {}) as Record<string, unknown>;

export const ptBr = (__LOCALE_PTBR__ ? ({
  [ns]: {
    breadcrumb: 'Usuários',
    active: 'Ativo',
    pending: 'Aguardando definição de senha',
    blocked: 'Bloqueado',
    info: {
      title: 'Útil saber',
      content: `
        <span>
          A lista de tags de acesso e listas do usuário é determinada por seus departamentos.
        </span>
        <span>
          A lista de acessos do usuário às páginas e objetos do sistema é determinada por seu papel.
        </span>
      `,
    },
  },
}) : {}) as Record<string, unknown>;
